import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/*
 * Interactive Mid-Atlantic service-area map.
 *
 * State outlines are real geographic shapes (US Census GeoJSON), projected
 * with an equirectangular projection — longitude compressed by cos(mean lat) —
 * and fitted to a 0 0 720 560 viewBox. Generated offline; see git history.
 *
 * NEIGHBORS render first in gray and non-interactive, for geographic context.
 * The three service-area states (PA, MD, VA) are hoverable/clickable, and
 * DC gets a labeled marker since the district is too small to click as a shape.
 */

const NEIGHBORS = [
	{
		id: 'de',
		label: 'DE',
		labelAt: [472, 307],
		path: 'M472.8,262.1 L469.4,267.9 L465.5,271.1 L466.3,278.7 L471.8,285.8 L473.2,297.6 L481.2,310.0 L484.8,310.5 L486.4,327.0 L462.5,326.5 L459.0,266.1 L465.3,260.8 L472.8,262.1 Z',
	},
	{
		id: 'ny',
		label: 'NY',
		labelAt: [483, 127],
		path: 'M549.5,12.3 L550.0,22.2 L547.9,31.2 L551.4,39.9 L550.4,49.0 L546.1,58.8 L549.3,71.9 L547.3,75.8 L553.2,83.7 L552.0,116.8 L552.4,121.0 L543.5,152.6 L541.8,190.7 L544.5,194.6 L535.3,199.9 L538.0,205.4 L553.8,209.3 L557.1,206.4 L570.7,206.4 L577.6,204.9 L588.9,197.2 L589.7,202.8 L595.6,205.1 L582.0,212.2 L553.4,222.7 L541.4,224.8 L533.5,224.3 L527.6,226.7 L524.4,218.8 L528.8,204.9 L516.5,198.0 L499.4,187.5 L497.8,184.1 L492.1,183.8 L485.4,175.7 L486.2,168.6 L481.8,163.1 L478.9,163.3 L474.9,156.8 L311.7,156.8 L311.7,144.7 L334.4,130.2 L338.1,123.7 L345.4,119.2 L342.5,111.1 L339.5,109.5 L337.3,96.3 L359.0,90.8 L378.3,91.1 L386.0,92.4 L394.3,97.7 L399.6,95.6 L415.6,95.8 L425.3,92.4 L435.7,83.7 L442.4,83.5 L442.6,70.3 L446.0,62.7 L437.7,57.5 L439.6,51.4 L454.4,43.3 L459.8,36.2 L477.7,20.1 L494.5,12.0 L519.7,13.3 L549.5,12.3 Z',
	},
	{
		id: 'nj',
		label: 'NJ',
		labelAt: [499, 245],
		path: 'M516.5,198.0 L528.8,204.9 L524.4,218.8 L518.3,221.9 L515.0,229.3 L525.2,233.0 L526.0,238.5 L521.5,264.2 L510.0,283.4 L502.5,288.9 L495.8,301.0 L492.3,293.1 L481.6,289.2 L468.4,278.7 L467.6,271.6 L469.4,267.9 L472.8,262.1 L482.8,258.2 L483.4,254.5 L494.8,246.6 L496.6,242.4 L486.0,232.7 L485.6,226.7 L481.0,225.1 L480.5,219.6 L486.2,211.2 L483.2,206.2 L492.5,196.2 L494.5,190.9 L499.4,187.5 L516.5,198.0 Z',
	},
	{
		id: 'wv',
		label: 'WV',
		labelAt: [262, 311],
		path: 'M283.7,222.2 L283.7,266.1 L322.3,266.1 L321.8,290.8 L329.2,286.3 L336.5,278.2 L341.3,279.7 L348.6,272.6 L359.6,276.1 L361.0,270.8 L367.1,271.1 L370.6,267.4 L376.8,271.9 L383.1,271.9 L387.4,285.3 L383.3,294.5 L364.1,278.4 L362.0,292.6 L344.8,312.1 L340.1,307.9 L332.2,324.9 L328.3,328.9 L322.3,326.8 L316.0,320.2 L313.1,331.2 L305.8,340.2 L303.0,348.8 L296.1,355.9 L292.0,363.6 L291.8,372.2 L285.3,376.4 L283.9,373.5 L267.1,382.7 L257.5,385.4 L252.4,380.4 L245.3,386.7 L240.7,386.9 L234.4,383.0 L229.3,374.9 L229.9,370.9 L225.0,370.1 L217.9,364.6 L216.1,359.1 L210.2,352.0 L205.8,342.8 L206.8,328.3 L216.5,327.3 L217.9,321.0 L222.4,318.4 L220.6,311.0 L227.5,299.4 L233.0,306.8 L236.8,302.3 L235.8,296.8 L240.5,287.6 L244.7,287.9 L249.0,281.1 L253.1,284.2 L257.7,282.1 L272.1,266.6 L275.6,249.0 L280.7,237.4 L280.9,230.1 L278.2,224.8 L283.7,222.2 Z',
	},
	{
		id: 'oh',
		label: 'OH',
		labelAt: [200, 250],
		path: 'M283.7,157.8 L283.7,222.2 L278.2,224.8 L280.9,230.1 L280.7,237.4 L275.6,249.0 L272.1,266.6 L257.7,282.1 L253.1,284.2 L249.0,281.1 L244.7,287.9 L240.5,287.6 L235.8,296.8 L236.8,302.3 L233.0,306.8 L227.5,299.4 L220.6,311.0 L222.4,318.4 L217.9,321.0 L216.5,327.3 L206.8,328.3 L201.7,321.8 L197.4,320.5 L195.8,312.3 L190.5,313.9 L186.5,318.6 L172.5,314.9 L166.6,318.4 L158.3,311.8 L146.7,310.0 L146.1,305.7 L138.6,295.8 L124.4,295.8 L125.0,228.8 L124.8,171.5 L174.9,169.6 L189.3,176.2 L194.2,180.2 L197.9,176.5 L206.0,184.1 L211.0,186.5 L228.3,180.2 L238.4,181.5 L249.4,172.5 L265.4,163.9 L283.7,157.8 Z',
	},
	{
		id: 'nc',
		label: 'NC',
		labelAt: [324, 469],
		path: 'M266.6,417.7 L292.0,418.5 L321.0,418.7 L456.0,418.2 L460.3,437.4 L449.9,435.5 L435.9,440.8 L425.8,444.2 L426.2,447.6 L436.3,445.3 L448.9,445.0 L452.5,449.5 L459.2,447.6 L461.7,459.2 L459.4,464.7 L455.0,465.2 L445.6,477.1 L433.3,477.6 L431.2,485.7 L436.5,493.9 L440.8,495.5 L432.9,508.9 L426.2,507.3 L414.4,508.6 L406.3,511.5 L393.5,520.7 L383.3,532.8 L378.1,548.0 L370.3,544.6 L357.0,547.7 L314.9,502.0 L273.3,501.2 L274.0,495.7 L268.3,487.6 L264.4,490.5 L264.2,485.5 L218.6,483.1 L208.4,484.9 L200.5,489.4 L187.7,492.6 L168.8,493.3 L142.9,493.1 L143.9,481.8 L151.2,480.7 L154.0,472.9 L163.1,465.8 L173.3,465.5 L182.4,458.1 L192.0,455.5 L200.1,444.7 L205.2,441.6 L206.2,446.3 L220.8,437.1 L227.5,439.0 L232.1,430.0 L239.0,427.7 L240.7,416.4 L266.6,417.7 Z',
	},
];

const STATES = [
	{
		id: 'pennsylvania',
		name: 'Pennsylvania',
		abbr: 'PA',
		labelAt: [380, 225],
		path: 'M311.7,144.7 L311.7,156.8 L474.9,156.8 L478.9,163.3 L481.8,163.1 L486.2,168.6 L485.4,175.7 L492.1,183.8 L497.8,184.1 L499.4,187.5 L494.5,190.9 L492.5,196.2 L483.2,206.2 L486.2,211.2 L480.5,219.6 L481.0,225.1 L485.6,226.7 L486.0,232.7 L496.6,242.4 L494.8,246.6 L483.4,254.5 L482.8,258.2 L472.8,262.1 L465.3,260.8 L459.0,266.1 L322.3,266.1 L283.7,266.1 L283.7,222.2 L283.7,157.8 L290.6,155.2 L311.7,143.9 L311.7,144.7 Z',
	},
	{
		id: 'virginia',
		name: 'Virginia',
		abbr: 'VA',
		labelAt: [360, 365],
		path: 'M473.4,348.1 L479.1,347.3 L474.3,355.4 L469.2,358.3 L466.1,369.3 L458.4,387.2 L452.1,390.9 L450.1,384.3 L453.4,369.6 L463.3,350.9 L473.4,348.1 Z M364.1,278.4 L383.3,294.5 L387.4,285.3 L393.1,286.0 L397.1,290.0 L397.1,297.1 L404.8,299.4 L409.7,303.9 L412.6,310.7 L409.3,318.4 L404.8,320.5 L402.0,327.3 L403.6,332.3 L413.6,330.7 L415.4,338.3 L428.4,341.5 L432.0,347.5 L442.4,354.1 L437.7,367.5 L442.0,378.0 L436.9,383.0 L436.3,389.0 L441.0,392.7 L435.9,398.5 L428.2,390.9 L426.4,393.5 L433.1,399.0 L451.3,400.3 L456.0,418.2 L321.0,418.7 L292.0,418.5 L266.6,417.7 L240.7,416.4 L166.8,415.8 L186.7,409.0 L189.1,403.8 L196.2,401.9 L196.6,397.7 L202.1,394.6 L202.1,390.9 L215.7,383.8 L229.9,370.9 L229.3,374.9 L234.4,383.0 L240.7,386.9 L245.3,386.7 L252.4,380.4 L257.5,385.4 L267.1,382.7 L283.9,373.5 L285.3,376.4 L291.8,372.2 L292.0,363.6 L296.1,355.9 L303.0,348.8 L305.8,340.2 L313.1,331.2 L316.0,320.2 L322.3,326.8 L328.3,328.9 L332.2,324.9 L340.1,307.9 L344.8,312.1 L362.0,292.6 L364.1,278.4 Z',
	},
	{
		id: 'maryland',
		name: 'Maryland',
		abbr: 'MD',
		labelAt: [420, 290],
		path: 'M322.3,266.1 L459.0,266.1 L462.5,326.5 L486.4,327.0 L479.1,347.3 L473.4,348.1 L463.3,350.9 L455.4,353.0 L455.6,345.2 L452.5,342.0 L456.8,338.6 L451.1,330.7 L449.3,334.1 L441.6,333.3 L438.9,324.7 L441.4,324.7 L441.6,313.4 L444.0,308.9 L440.8,293.7 L444.8,284.7 L451.1,283.2 L452.1,274.0 L447.5,275.0 L447.3,279.7 L437.5,285.8 L434.7,291.3 L434.1,305.2 L430.4,311.8 L432.0,322.8 L436.9,330.4 L436.3,336.2 L439.3,342.0 L437.7,345.9 L429.2,338.3 L417.0,334.7 L413.4,327.3 L406.5,331.5 L403.8,325.7 L409.3,318.4 L412.6,310.7 L417.4,305.7 L412.8,301.0 L409.7,303.9 L404.8,299.4 L397.1,297.1 L397.1,290.0 L393.1,286.0 L387.4,285.3 L383.1,271.9 L376.8,271.9 L370.6,267.4 L367.1,271.1 L361.0,270.8 L359.6,276.1 L348.6,272.6 L341.3,279.7 L336.5,278.2 L329.2,286.3 L321.8,290.8 L322.3,266.1 Z',
	},
];

const DC = {
	id: 'dc',
	name: 'Washington DC',
	at: [412.7, 305.2],
	labelAt: [430, 300],
};

export default function ServiceAreaMap({ active: activeProp, onActiveChange }) {
	const navigate = useNavigate();
	const [activeInternal, setActiveInternal] = useState(null);

	// Controlled when an `active` prop is supplied (e.g. the chips drive it);
	// otherwise the map manages its own hover/focus state.
	const isControlled = activeProp !== undefined;
	const active = isControlled ? activeProp : activeInternal;
	const setActive = (id) => {
		if (!isControlled) setActiveInternal(id);
		onActiveChange?.(id);
	};

	const go = (id) => navigate(`/service-areas/${id}`);

	const handleKey = (event, id) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			go(id);
		}
	};

	const activeName =
		active === DC.id
			? DC.name
			: STATES.find((state) => state.id === active)?.name;

	return (
		<div className='relative'>
			<svg
				viewBox='0 0 720 560'
				className='h-auto w-full overflow-visible drop-shadow-sm'
				role='group'
				aria-label='Interactive map of Solar Gabe service areas'
			>
				{/* Context states — gray, non-interactive */}
				{NEIGHBORS.map((n) => (
					<g
						key={n.id}
						aria-hidden='true'
					>
						<path
							id={`area-${n.id}`}
							d={n.path}
							className='fill-ink-100 stroke-white'
							strokeWidth={1.5}
							strokeLinejoin='round'
						/>
						<text
							x={n.labelAt[0]}
							y={n.labelAt[1]}
							textAnchor='middle'
							className='pointer-events-none select-none fill-ink-400 font-medium'
							style={{ fontSize: 13 }}
						>
							{n.label}
						</text>
					</g>
				))}

				{/* Service areas — interactive */}
				{STATES.map((state) => {
					const isActive = active === state.id;
					return (
						<g
							key={state.id}
							role='link'
							tabIndex={0}
							aria-label={`${state.name} solar services`}
							onClick={() => go(state.id)}
							onKeyDown={(event) => handleKey(event, state.id)}
							onMouseEnter={() => setActive(state.id)}
							onMouseLeave={() => setActive(null)}
							onFocus={() => setActive(state.id)}
							onBlur={() => setActive(null)}
							className='cursor-pointer outline-none'
						>
							<path
								id={`area-${state.id}`}
								d={state.path}
								className={`transition-all duration-200 ${
									isActive
										? 'fill-primary-500 stroke-white'
										: 'fill-primary-200 stroke-white hover:fill-primary-300'
								}`}
								strokeWidth={isActive ? 2.5 : 1.75}
								strokeLinejoin='round'
							/>
							<text
								x={state.labelAt[0]}
								y={state.labelAt[1]}
								textAnchor='middle'
								className={`pointer-events-none select-none font-semibold transition-colors duration-200 ${
									isActive ? 'fill-white' : 'fill-primary-800'
								}`}
								style={{ fontSize: state.labelSmall ? 12 : 20 }}
							>
								{state.abbr}
							</text>
						</g>
					);
				})}

				{/* DC marker — too small to draw as a clickable shape, so it's a
				    defined callout: leader line out to a labeled pill, ringed dot. */}
				{(() => {
					const isActive = active === DC.id;
					// Pill sits up-and-right of the dot, with a leader line to it.
					const px = 528;
					const py = 318;
					const pw = 74;
					const ph = 30;
					return (
						<g
							role='link'
							tabIndex={0}
							aria-label='Washington DC solar services'
							onClick={() => go(DC.id)}
							onKeyDown={(event) => handleKey(event, DC.id)}
							onMouseEnter={() => setActive(DC.id)}
							onMouseLeave={() => setActive(null)}
							onFocus={() => setActive(DC.id)}
							onBlur={() => setActive(null)}
							className='cursor-pointer outline-none'
						>
							{/* Leader line from the dot to the pill */}
							<line
								x1={DC.at[0]}
								y1={DC.at[1]}
								x2={px}
								y2={py + ph / 2}
								className={`transition-colors duration-200 ${
									isActive ? 'stroke-primary-600' : 'stroke-ink-300'
								}`}
								strokeWidth={1.75}
							/>
							{/* Halo ring + dot */}
							<circle
								cx={DC.at[0]}
								cy={DC.at[1]}
								r={isActive ? 11 : 9}
								className={`transition-all duration-200 ${
									isActive ? 'fill-primary-200' : 'fill-white'
								}`}
								opacity={isActive ? 0.9 : 0.85}
							/>
							<circle
								cx={DC.at[0]}
								cy={DC.at[1]}
								r={isActive ? 6.5 : 5}
								className={`transition-all duration-200 stroke-white ${
									isActive ? 'fill-primary-600' : 'fill-primary-500'
								}`}
								strokeWidth={2}
							/>
							{/* Label pill */}
							<rect
								x={px}
								y={py}
								width={pw}
								height={ph}
								rx={ph / 2}
								className={`transition-all duration-200 ${
									isActive
										? 'fill-primary-500 stroke-primary-600'
										: 'fill-white stroke-ink-200'
								}`}
								strokeWidth={1.5}
							/>
							<text
								x={px + pw / 2}
								y={py + ph / 2 + 4.5}
								textAnchor='middle'
								className={`pointer-events-none select-none font-semibold transition-colors duration-200 ${
									isActive ? 'fill-white' : 'fill-ink-700'
								}`}
								style={{ fontSize: 13 }}
							>
								D.C.
							</text>
						</g>
					);
				})()}
			</svg>

			{/* Hover/focus readout */}
			<div className='pointer-events-none absolute bottom-2 left-1/2 -translate-x-1/2'>
				<span
					className={`rounded-full bg-ink-900 px-4 py-2 text-sm font-medium text-white shadow-lg transition-opacity duration-200 ${
						activeName ? 'opacity-100' : 'opacity-0'
					}`}
				>
					{activeName || ''} →
				</span>
			</div>
		</div>
	);
}
